// composables/useToast.js
import { computed } from 'vue'
import { useToastStore } from '../stores/toast'

export default function useToast() {
  const toastStore = useToastStore()

  return {
    // computed properties
    show: computed(() => toastStore.show),
    message: computed(() => toastStore.message),
    type: computed(() => toastStore.type),
    duration: computed(() => toastStore.duration),

    // methods
    showToast: toastStore.showToast,
    toastSuccess: (message, duration) => toastStore.showToast(message, 'success', duration),
    toastError: (message, duration) => toastStore.showToast(message, 'error', duration),
    toastWarning: (message, duration) => toastStore.showToast(message, 'warning', duration),
    toastInfo: (message, duration) => toastStore.showToast(message, 'info', duration),
    closeToast: toastStore.closeToast,
  }
}

// named export
export { useToast }